import BlockedProductsPreview from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/BlockedProductsPreview/BlockedProductsPreview'
import { copyGroups } from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/constants'
import ErrorDialogsPreview from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/ErrorDialogsPreview/ErrorDialogsPreview'
import MiscPreview from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/MiscPreview/MiscPreview'
import RequestSummaryPreview from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/RequestSummaryPreview/RequestSummaryPreview'
import ReturnMethodsPreview from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/ReturnMethodsPreview/ReturnMethodsPreview'

const CopyPreview = ({
  selectedTab,
  activePreview,
  customCopies,
  lang,
  returnsPortalUrl,
  merchantInfo,
  address,
  isCustomCopyActive,
}) => {
  if (selectedTab === copyGroups.misc) {
    return (
      <MiscPreview
        activeMiscType={activePreview}
        customCopies={customCopies}
        lang={lang}
        previewUrl={returnsPortalUrl}
        isCustomCopyActive={isCustomCopyActive}
      />
    )
  }

  if (selectedTab === copyGroups.blockedProducts) {
    return (
      <BlockedProductsPreview
        activeBlockedProduct={activePreview}
        customCopies={customCopies}
        lang={lang}
        merchantInfo={merchantInfo}
      />
    )
  }

  if (selectedTab === copyGroups.errorDialogs) {
    return (
      <ErrorDialogsPreview
        activeErrorDialog={activePreview}
        customCopies={customCopies}
        lang={lang}
        merchantInfo={merchantInfo}
        isActive={isCustomCopyActive(activePreview)}
      />
    )
  }

  if (selectedTab === copyGroups.deliveryMethods) {
    return (
      <ReturnMethodsPreview
        activeReturnMethod={activePreview}
        customCopies={customCopies}
        lang={lang}
        merchantInfo={merchantInfo}
        isActive={isCustomCopyActive(activePreview)}
        address={address}
      />
    )
  }

  if (selectedTab === copyGroups.requestSummary) {
    return (
      <RequestSummaryPreview
        activeRequestSummary={activePreview}
        customCopies={customCopies}
        lang={lang}
        isActive={isCustomCopyActive(activePreview)}
      />
    )
  }

  return null
}

export default CopyPreview
